/* eslint-disable no-restricted-globals */
import { cloneDeep } from "lodash";
import React, { useState } from "react";
import { FaEye } from "react-icons/fa";
import { VscHistory } from "react-icons/vsc";
import { useNavigate } from "react-router-dom";
import addPrecision from "../../common/addPrecision";
import AppButton from "../../common/AppButton";
import AppModal from "../../common/AppModal";
import PaymentsLogModel from "../jobs/PaymentsLogModel";
import { observer } from "mobx-react-lite";
import {
  getPaymentsGroupedByContractInv,
  getPaymentsGroupedByJob,
} from "../../stores/PaymentStore";
import { useQuery } from "@tanstack/react-query";
import { getPosGroupedByJob } from "../../stores/PoStore";

const InvoiceResult = ({ list }) => {
  const navigate = useNavigate();
  const PLog = PaymentsLogModel();
  const [model, setModel] = useState({});
  console.log(list);
  const { data: paymentsGroupedByJob } = useQuery({
    queryFn: () => getPaymentsGroupedByJob(),
    queryKey: ["payments", "groupedByJob"],
  });

  const { data: posGroupedByJob } = useQuery({
    queryFn: () => getPosGroupedByJob(),
    queryKey: ["pos", "groupedByJob"],
  });

  const { data: paymentsGroupedByContractInv } = useQuery({
    queryFn: () => getPaymentsGroupedByContractInv(),
    queryKey: ["payments", "groupedByContractInv"],
  });

  console.log(posGroupedByJob);
  console.log(paymentsGroupedByJob);

  return (
    <div>
      <table className="table table-default">
        <thead>
          <tr>
            <th>Invoice ID </th>
            <th>Client</th>
            <th>Location</th>
            <th>Po No</th>
            <th>Amount</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {list?.map((inv) => {
            const pos = posGroupedByJob?.[inv._id];
            const poNo = pos ? pos[pos.length - 1]?.poNo : undefined;
            const payments = inv.contract
              ? paymentsGroupedByContractInv?.[inv._id]
              : paymentsGroupedByJob?.[inv._id];
            const totalPaid = payments?.reduce(
              (redu, item) => (redu += Number(item.amount.replaceAll(",", ""))),
              0
            );
            const totAmount = Number(
              typeof inv.total === "string"
                ? inv.total.replaceAll(",", "")
                : inv.total
            );
            const paymentStatus =
              totalPaid === totAmount
                ? "full"
                : totalPaid > 0
                ? "partial"
                : "no";

            return (
              <tr key={inv._id}>
                <td style={{ minWidth: 150 }}>{inv.invoiceID}</td>
                <td>
                  {inv.organization?.name || inv.contract?.organizationName}
                </td>
                <td>{`${inv.location?.map((i) => i.title).join(", ")}`}</td>
                <td>{poNo || " - "}</td>
                <td>{`$ ${addPrecision(inv.total)}`}</td>
                <td>
                  <div
                    className="side-button"
                    style={{
                      width: 70,
                      borderWidth: 1,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        minWidth: 15,
                        minHeight: 15,
                        maxWidth: 15,
                        maxHeight: 15,
                        borderRadius: 100,
                        backgroundColor:
                          paymentStatus === "no"
                            ? "red"
                            : paymentStatus === "partial"
                            ? "blue"
                            : "white",
                      }}
                    ></div>
                    <AppButton
                      leftIcon={<FaEye />}
                      tooltip="View"
                      className="text-primary "
                      onClick={() => {
                        const { pathname } = location;
                        if (inv.contract) {
                          navigate("/contracts/invoice", {
                            state: {
                              data: {
                                ...inv,
                                invoiceID: inv?.invoiceID,
                                tax: inv?.tax,
                                price: inv?.price,
                                total: inv?.total,
                                startDate: inv?.startDate,
                              },
                            },
                          });
                        } else {
                          navigate(pathname + "/invoiceToPdf", {
                            state: {
                              data: cloneDeep({ ...inv, poNo }),
                              noSettings: true,
                            },
                          });
                        }
                      }}
                    />
                    <AppButton
                      tooltip="Payments Log"
                      className="text-primary"
                      onClick={() => {
                        setModel({
                          visible: true,
                          header: <PLog.Header invoiceId={inv.invoiceId} />,
                          body: <PLog.Body payments={payments} />,
                        });
                      }}
                      leftIcon={<VscHistory />}
                    />
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <AppModal
        onHide={() => {
          setModel({});
        }}
        {...model}
      />
    </div>
  );
};

export default observer(InvoiceResult);
